/* istanbul ignore file */
export default (...reducers) => (state, action) => {
  return reducers.reduce((nextState, reducer) => reducer(nextState, action), state);
};
